// Inline copy for a refused admin change, shown on the still-open dialog while
// the page refetches behind it, so the admin is pointed at the current status
// rather than told to reload. Use it only where useApi has toasted the
// server's own message, because this line names no cause: the order cancel
// (whose transition call toasts every failure), and the client status change
// for every failure it does not explain itself (Clients/_helpers/
// statusChange.ts says 400, 403, 404 and 409 inline and suppresses only those
// toasts).
export const failedChangeMessage = (whatDidNotHappen: string): string =>
    `${whatDidNotHappen} Check the current status on this page before trying again.`;
